import { Signature } from 'ethers';
import { Web3Provider } from '@ethersproject/providers';

const signMessage = async (
    library: any,
    account: string,
    message: any
): Promise<Signature> => {
    let web3Provider, isMetamask, signature;

    if (library instanceof Web3Provider) {
        web3Provider = library;
        isMetamask = web3Provider.provider.isMetaMask;

        if (isMetamask) {
            web3Provider.provider.isMetaMask = false;
        }
    }

    if (isMetamask) {
        try {
            signature = await library.send('personal_sign', [account, message]);
        } catch (error) {
            throw error;
        } finally {
            (web3Provider as Web3Provider).provider.isMetaMask = true;
        }
    } else {
        signature = await library.send('personal_sign', [account, message]);
    }

    return signature;
};

export default signMessage;
